import AService from '@/services/AService';

const ENTITY_NAME = 'special-requests';
export default class SpecialRequestService extends AService {

  /**
   * Création d'une demande spéciale
   * @param  {SpecialRequestCreateRequest} request la demande spéciale
   * @returns {Promise<SpecialRequestFullDto>} la demande spéciale créée
   */
  async create(request) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, request)
    return response.data
  }

  /**
   * Récupération des demandes spéciales
   * @param {SpecialRequestFilter} filter le filtre de recherche
   * @return {Promise<Page<SpecialRequestDto>>}
   */
  async fetchAll(filter) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}`, {params: filter})
    return response.data
  }

  /**
   * Récupération d'une demande spéciale
   * @param id l'identifiant de la demande spéciale
   * @return {Promise<SpecialRequestFullDto>}
   */
  async findById(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }

  /**
   * Changement de statut d'une demande spéciale
   * @param {SpecialRequestUpdateRequest} updateRequest la demande spéciale à mettre à jour
   * @return {Promise<SpecialRequestFullDto>}
   */
  async update(updateRequest){
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}/${updateRequest.id}`, updateRequest)
    return response.data
  }
}
